import LandingPage from '../templates/LandingPage';
import starMoving from '../../assets/svg/star-moving.svg';
import Button from '../components/common/Button';
import lighting from '../../assets/svg/lighting.svg'
import rectDot from '../../assets/svg/rect-dot.svg'
// import easy from '../../assets/svg/easy.svg'
import vid from '../../assets/images/vid.png'
import play from '../../assets/svg/play.svg'
// import testimony from '../../assets/svg/testimony.svg'
import aboki from '../../assets/images/Mallam_1.png'
import cap from '../../assets/images/cap.png'
import phone1 from '../../assets/svg/phone1.svg'
import phone2 from '../../assets/svg/phone2.svg'
import pattern4 from '../../assets/svg/pattern4.svg'
import notification from '../../assets/images/alert.png'
import seller from '../../assets/svg/Hand_manipulation.png'
import Badge from '../components/common/Badge';
import Gif1 from '../../assets/images/gif-1.png'
import Gif2 from '../../assets/images/gif-2.png'
import Gif3 from '../../assets/images/gif-3.png'
import ArrowDown from '../../assets/svg/arrow-down.svg'
import TVColour from '../../assets/images/tv-coloured.png'
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";
import { useEffect, useState } from 'react';
import { getMerchant } from '../../services/merchant'
import { getLocation } from '../../services/widget';


function App() {
  let [section4Img, setSection4Img] = useState(1);
  let [section5Img, setSection5Img] = useState(1);
  const [showSell, setShowSell] = useState(false);
  const [location, setLocation] = useState({})

  const merchant = JSON.parse( window.localStorage.getItem("bMerchant") || "[]") || []

  const animateSection4 = () => {
    let next = 1
    setInterval( () => {
      next = next === 3 ? 1 : ++next
      setSection4Img( next )
    }, 1000)
  }

  const animateSection5 = () => {
    let next = 1
    setInterval( () => {
      next = next === 3 ? 1 : ++next
      setSection5Img( next )
    }, 1000)
  }

  useEffect( () => {
    animateSection4()
    animateSection5()

    if(!window.localStorage.getItem("bMerchant")) {
      getMerchant().then( res => {
        changeFavIcon(res.logo);
      })
    }

    getLocation().then( res => {
      setLocation(res)
    }).catch(err => {
      console.log(err)
    }).finally()
    
  }, [])


  const changeFavIcon = logo => {
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = logo;
  }

  const scrollIt = (destination, duration = 200, easing = 'linear', callback) => {

    const easings = {
      linear(t) {
        return t;
      }
    };
  
    const start = window.pageYOffset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
  
    const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
    const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
    const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
  
    if ('requestAnimationFrame' in window === false) {
      window.scroll(0, destinationOffsetToScroll);
      if (callback) {
        callback();
      }
      return;
    }
  
    function scroll() {
      const now = 'now' in window.performance ? performance.now() : new Date().getTime();
      const time = Math.min(1, ((now - startTime) / duration));
      const timeFunction = easings[easing](time);
      window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));
  
      if (window.pageYOffset === destinationOffsetToScroll) {
        if (callback) {
          callback();
        }
        return;
      }
  
      requestAnimationFrame(scroll);
    }
  
    scroll();
  }

  
  return (
    <LandingPage sell={showSell}>
      <div className="px-8 lg:px-16 py-18 flex flex-col justify-center items-center h-screen section-one lg:truncate relative z-10">
        <div className="flex flex-col justify-center items-center mt-6 text-white">
          <p className="text-5xl text-center font-bold font-african text-yellow landing-page-breadcum" >
            {/* Sell Bitcoin,<br/> 
            Get Naira Asap! */}
            No Sign up Required!
          </p>
          <span className="text-md lg:text-3xl text-center font-avenir break-words mb-3" >
            {/* Just think of us as your surest bitcoin padi. <br/> We dey your side. */}
            {/* We have just one mission; to help you convert your bitcoin to naira without stress. Just think of us as your surest bitcoin padi. */}
            Sell Bitcoin, Get Naira Asap!
          </span>
          <span className="text-xs lg:text-sm text-center font-avenir break-words">
          Just think of us as your surest bitcoin padi. <br/>We dey your side. 
          </span>
          <Button onClick={() => setShowSell(!showSell)} className="text-brown-dark border-0 bg-yellow flex items-center m-4 text-sm px-5 py-4 lg:px-16 lg:py-5 rounded-sm font-bold">
            <img src={lighting} alt="z" width="10px"/> &nbsp; Sell your BTC @ ₦{ merchant.buying_at || "425"}
          </Button>
        </div>
        <div className="w-full flex overflow-hidden bottom-0 bg-red truncate" >
          <div className="sm:w-full overflow-hidden h-screen lg:w-5/12 absolute left-0 bottom-0 ">
            {/* <ScrollAnimation animateIn="bounceInLeft" animateOut='bounceInLeft' delay="100"> */}
              <img src={seller} alt="z" className="absolute bottom-0 mobile-img-landing-left aboki-cap" />
            {/* </ScrollAnimation>  */}
          </div>
          <div className="sm:w-full overflow-hidden h-screen lg:w-5/12 absolute right-0 bottom-0 aboki">
            {/* <ScrollAnimation animateIn="bounceOutRight" animateOut='bounceOutRight' delay="100"> */}
              <img src={aboki} alt="z" className="absolute bottom-0 -mb-8 mobile-img-landing-right right-0 transform -rotate-3" />
            {/* </ScrollAnimation> */}
          </div>
        </div>
        {/* <ScrollAnimation animateIn="tada" delay="0" className="z-50"> */}
          <img src={cap} alt="z" className="fixed bottom-0 mb-20 mr-12 mobile-img-landing-right right-0 cursor-pointer z-20" onClick={() => setShowSell(!showSell)} />
        {/* </ScrollAnimation> */}
        <div className="absolute bottom-0 right-0 left-0 mb-20 flex justify-center">
          <span className="cursor-pointer text-sm flex text-yellow cursor-pointer" onClick={ () => scrollIt(document.querySelector('#footer'), 1000) }>Scroll to bottom &nbsp; <img src={ArrowDown} width="20px" alt="v"/></span>
        </div>
      </div>
      <div className="px-8 lg:px-16 py-12 flex flex-col bg-blue-lighter justify-center items-center bg-blue-lighter section-two">
        <div className="flex">
          <img src={starMoving} alt="*" width="60px" /> &nbsp;
          <img src={starMoving} alt="*" width="60px" /> &nbsp;
          <img src={starMoving} alt="*" width="60px" /> &nbsp;
          <img src={starMoving} alt="*" width="60px" /> &nbsp;
          <img src={starMoving} alt="*" width="60px" /> &nbsp;
        </div>
        <p className="text-white text-xl lg:text-3xl text-center">We are the biggest buyer of bitcoin in { location.region || "Lagos" }, { location.country_name || "Nigeria" }</p>
      </div>
      <div className="px-8 lg:px-32 sm:pt-8 lg:pt-16 flex flex-col bg-teal-100 section-three">
        <div className="flex flex-col mt-12 text-black">
          <p className="text-4xl text-center text-brown-dark font-african landing-page-breadcum">
            No Long Talk!<br/>
            Sell your Bitcoin in 2 easy steps!
          </p>
          <span className="text-sm text-center py-4 text-lg lg:text-2xl">
          {/* BitcoinAboki lets you skip the registration process and get into transacting immediately. */}
          A tool that lets you skip the registration process and get straight into transacting immediately.
          </span>
        </div>
        <div className="grid grid-cols-2 lg:gap-8 lg:mt-12">

         
          <div className="pt-6 px-2 lg:px-6 flex justify-end">
            <ScrollAnimation animateIn="bounceInLeft" animateOut='bounceOutRight' delay="100">
              <img src={phone1} alt="phone 1"/>
            </ScrollAnimation>
          </div>
          

          <div className="pt-6 px-2 lg:px-6 relative">
            
            <div className="absolute left-0 mt-8">
              <ScrollAnimation animateIn="tada" delay="2100" className="z-20 relative">
                <img src={notification} alt="notification"/>
              </ScrollAnimation>
            </div>
            <ScrollAnimation animateIn="bounceInRight" className="z-10 relative" animateOut="bounceOutLeft" delay="1100">
              <img src={phone2} alt="phone 2"/>
            </ScrollAnimation>
          </div>

          {/* <div className="bg-blue-lighter py-6 px-12 pb-16 text-white rounded-lg">
            <div className="w-full flex justify-end">
              <span className="w-12 h-12 bg-white rounded-full font-bold flex justify-center items-center bg-opacity-8">2</span>
            </div>
            <h2 className="pb-8 pt-4 text-xl font-bold">Send Bitcoin</h2>
            <p>You’ll be provided with a unique wallet address to send the bitcoin.</p>
          </div> */}

        </div>
      </div>

      <div className="bg-yellow flex flex-col flex-col lg:flex-row py-12 px-8 lg:px-16 pt-8 lg:pt-32 relative lg:h-screen">
        <div className="absolute top-0 left-0 right-0">
          <img src={pattern4} alt="pa" />
        </div>

        <div className="flex flex-col sm:flex-col lg:flex-row w-full">
          <div className="w-full lg:w-1/2">
            <img src={Gif1} alt="*" className={`${section4Img === 1 ? '' : 'hidden'}`}/>
            <img src={Gif2} alt="*" className={`${section4Img === 2 ? '' : 'hidden'}`}/>
            <img src={Gif3} alt="*" className={`${section4Img === 3 ? '' : 'hidden'}`}/>
          </div>
          <div className="ml-2 sm:ml-2 lg:ml-8 w-full lg:w-1/2">
            <Badge className="text-xs lg:text-sm bg-red text-white mb-12 rounded-full lg:inline-flex">
            Why 5,327 Correct People use BitcoinAboki ?
            </Badge>
            <p className="text-4xl font-bold text-black">
              We’ve made it <br/>
              easy because <br />
              nobody likes <br/>
              Stress!
            </p>
            <div>
              <p className="flex items-center py-2 text-sm lg:text-md">
                <img src={rectDot} alt="." width="15px" /> &nbsp; &nbsp; &nbsp;
                <del className="text-red">Sign up required</del> &nbsp; &nbsp;
                <span className="text-black">No long thing</span>
              </p>
              <p className="flex items-center py-2 text-sm lg:text-md">
                <img src={rectDot} alt="." width="15px" /> &nbsp; &nbsp; &nbsp;
                <del className="text-red">BVN, Wallet or OTP Required</del> &nbsp; &nbsp;
                <span className="text-black">Sharp sharp</span>
              </p>
              <p className="flex items-center py-2 text-sm lg:text-md">
                <img src={rectDot} alt="." width="15px" /> &nbsp; &nbsp; &nbsp;
                <del className="text-red">Delayed Payment</del> &nbsp; &nbsp;
                <span className="text-black">For where ?</span>
              </p>
              <p className="flex items-center py-2 text-sm lg:text-md">
                <img src={rectDot} alt="." width="15px" /> &nbsp; &nbsp; &nbsp;
                <del className="text-red">Withdrawal Limit</del> &nbsp; &nbsp;
                <span className="text-black">No Withdrawal Limit</span>
              </p>
            </div>
          </div>
        </div>
        

        <div className="absolute bottom-0 left-0 right-0">
          <img src={pattern4} alt="pa" />
        </div>
      </div>

      <div className="px-12 lg:px-32 py-10 lg:py-24 flex flex-col bg-teal-100 justify-center items-center section-five">
        <div className="flex justify-center items-center">
            {/* <img className="relative z-10" src={tv} alt="tv"  /> */}
            <img src={TVColour} alt="*" className={`${section5Img === 1 ? '' : 'hidden'}`}/>
            <img src={vid} alt="*" className={`${section5Img === 2 ? '' : 'hidden'}`}/>
            <img src={TVColour} alt="*" className={`${section5Img === 3 ? '' : 'hidden'}`}/>
        </div>
        <div className="">
          <p className="text-3xl font-african py-8 text-brown-dark text-center">
          Our inspiration in A minute
          </p>
        </div>
        <div className="">
            <Button className="text-white border-0 bg-brown-dark flex items-center m-4 text-xs px-5 py-3 rounded-md font-bold">
              <img src={play} alt="play" width="10px"/> &nbsp; Watch our 1 mins video
            </Button>
        </div>
      </div>
    </LandingPage>
  );
}

export default App;
